<template>
  <b-card border-variant="dark" title="سوالات انتخاب شده برای آزمون">
    <p
      class="text-center"
      v-if="!questionsList || (questionsList && questionsList.length == 0)"
    >
      شما هنوز هیچ سوالی را انتخاب نکرده‌اید!
    </p>
    <div v-else>
      <ol>
        <li
          class="my-1"
          v-for="question in questionsList"
          :key="question.questionId"
        >
          <div class="d-flex align-items-center justify-content-between">
            <p dir="auto">
              {{ question.questionText }}
            </p>
            <b-button
              variant="transparent"
              size="sm"
              @click="removeOldQuestion(question)"
            >
              <feather-icon
                icon="Trash2Icon"
                size="20"
                class="text-danger"
                v-if="question.oldQuestion"
              />
            </b-button>
          </div>
          <div class="w-100">
            <b-form-radio class="mt-1" name="answer">
              <p
                dir="auto"
                :class="
                  isCorrectAnswer(question, 'a')
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                {{ question.a }}
              </p>
            </b-form-radio>
            <b-form-radio class="mt-1" name="answer">
              <p
                dir="auto"
                :class="
                  isCorrectAnswer(question, 'b')
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                {{ question.b }}
              </p>
            </b-form-radio>
            <b-form-radio class="mt-1" name="answer">
              <p
                dir="auto"
                :class="
                  isCorrectAnswer(question, 'c')
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                {{ question.c }}
              </p>
            </b-form-radio>
            <b-form-radio class="mt-1" name="answer">
              <p
                dir="auto"
                :class="
                  isCorrectAnswer(question, 'd')
                    ? 'text-success'
                    : 'text-danger'
                "
              >
                {{ question.d }}
              </p>
            </b-form-radio>
          </div>
        </li>
      </ol>
    </div>
  </b-card>
</template>
<script>
export default {
  emits: ["removeQuestion"],
  props: {
    questionsList: {
      type: Array,
      required: false,
    },
  },
  methods: {
    removeOldQuestion(questionInfo) {
      this.$emit("removeQuestion", questionInfo);
    },
    isCorrectAnswer(question, answer) {
      if (question.correctAnswer == answer) {
        return true;
      }
      return false;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormFile,
    BForm,
    BFormGroup,
    BFormRadio,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
